
const menu = require('../../../../../components/menu/menu')
const dtHandler = require('../../../../../components/dt/dt-handler')

export function start(detail, htmlDt, htmlFc) {

  const menuElem = menuBody[detail.id]

  for (let i = 0; i < menuElem.length; i++) {
    menuElem[i].start(detail, htmlDt, htmlFc)
  }

  detail.html = menuElem
  detail.act = 'show'
  menu.start(detail)

}


const menuBody = {

  trMenu: [

    {
      text: '',
      svg: 'eye',
      class: ``,
      dataDetail: ``,

      start: function (detail) {
        this.text = 'View/Edit'        //language.start('inProgress')     
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              { "dest":"provider", "elem":"fullcont", "id":"provider-fullcont", "act":"selectOne",  "entity":"provider", "dbid": ${detail.dbid} }
           ]}'`

      }
    },


    {
      text: '',
      svg: 'payable',
      class: ``, //same name as the title test

      dataDetail: '',

      start: function (detail) {
        this.text = 'Acc. Payable'        //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"provider", "elem":"fullcont", "entity":"provider", "reportName":"account-payable-one", "dbid":"${detail.dbid}", "act":"printReport"}
        ]}'`

      }

    },

    {
      text: '',
      svg: 'profit',
      class: ``, //same name as the title test

      dataDetail: '',

      start: function (detail) {
        this.text = 'Profit Report'        //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"provider", "elem":"fullcont", "entity":"provider", "reportName":"account-all-profit", "dbid":"${detail.dbid}", "act":"printReport"}

        ]}'`

      }

    },

    { text: 'line', start: function () { } }, //////////////line

    {
      text: '',
      svg: 'delete',
      class: ``,
      dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}
        ]}'`,

      start: function (detail) {

        this.text = 'Delete'        //language.start('inProgress')     
        this.dataDetail = `data-detail='{
                            "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"provider", "elem":"fullcont", "act":"deleteEntity", "entity":"provider", "dbid":["${detail.dbid}"] } 
           ]}'`

      }
    },
  ],

  tableOptions: [

    {
      text: '',
      svg: 'payable',
      class: ``, //same name as the title test

      dataDetail: '',

      start: function (detail) {
        this.text = 'Acc. Payable All'        //language.start('inProgress')
        this.dataDetail = `data-detail='{
                      "click": [
                          {"dest":"ripple" },
                          {"dest":"menu", "act":"hide"}, 
                          {"dest":"provider", "elem":"fullcont", "entity":"provider", "reportName":"account-payable-all", "act":"printReport"}

    ]}'`

      }

    },

    {
      text: '',
      svg: 'profit',
      class: ``, //same name as the title test

      dataDetail: `data-detail='{
                        "click": [
                            {"dest":"ripple" },
                            {"dest":"menu", "act":"hide"},
                            {"dest":"provider", "elem":"fullcont", "entity":"provider", "reportName":"account-all-profit", "act":"printReport"}
      ]}'`,


      start: function () {
        this.text = 'Profit Report All'        //language.start('inProgress')     
      }
    },

    {
      text: '',
      svg: 'contact_page',
      class: ``, //same name as the title test

      dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"},
                              {"dest":"provider", "elem":"fullcont", "entity":"provider", "reportName":"provider-contact-directory", "act":"printReport"}
        ]}'`,


      start: function () {
        this.text = 'All Contacts'        //language.start('inProgress')     
      }
    },

    { text: 'line', start: function () { } }, //////////////line

    {
      text: '',
      svg: 'delete',
      class: ``,
      dataDetail: ``,



      start: function (detail, htmlDt) {  //console.log('startXXXXXXXXXXXXX')

        const ids = dtHandler.getTrChecked(htmlDt)

        //if exist one check
        if (ids.length > 0) {
          this.class = ``
          this.text = `Delete All (${ids.length})`
          this.dataDetail = `data-detail='{
                                    "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"provider", "elem":"fullcont", "act":"deleteEntity", "entity":"provider",  "dbid":[${ids}]} ]}'`
        } else {
          this.class = `disabled`
          this.text = `Delete All`
          this.dataDetail = ''
        }/*if*/

        // console.log('startXXXXXXXXXXXXX', ids)


      }/**/
    },
  ],

  fullcontOptions: [

    {
      text: '',
      svg: 'edit',
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {
        this.text = `Edit`
        this.dataDetail = `data-detail='{
                                   "click": [
                                      {"dest":"ripple" },
                                      {"dest":"menu", "act":"hide"},
                                      {"dest":"provider", "elem":"fullcont",  "id":"provider-fullcont", "act":"prepareEdit" }  ]}'`
      }/**/
    },

    // {
    //   text: '',
    //   svg: 'print',
    //   class: ``, //same name as the title test
    //   dataDetail: ``,

    //   start: function (detail, htmlDt, htmlFc) {

    //     //if exist one check
    //     this.class = ``
    //     this.text = `Print`
    //     this.dataDetail = `data-detail='{
    //                                  "click": [
    //                                     {"dest":"ripple" },
    //                                     {"dest":"menu", "act":"hide"},
    //                                     {"dest":"provider", "elem":"dt", "act":"trPrint"} ]}'`
    //   }/**/
    // },


    {
      text: '',
      svg: 'payable',
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {

        //if exist one check
        this.class = ``
        this.text = `Acc. Payable`
        this.dataDetail = `data-detail='{
                                     "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"provider", "elem":"fullcont", "entity":"provider", "reportName":"account-payable-one", "act":"printReport"} ]}'`
      }/**/
    },

    {
      text: '',
      svg: 'profit',
      class: ``, //same name as the title test

      dataDetail: '',

      start: function (detail) {
        this.text = 'Profit Report'        //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"provider", "elem":"fullcont", "entity":"provider", "reportName":"account-all-profit", "act":"printReport"} 
        ]}'`

      }

    },



    { text: 'line', start: function () { } }, //////////////line

    {
      text: '',
      svg: 'delete',
      class: ``, //same name as the title test

      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {

        const dbid = htmlFc.fullcontHTML.getAttribute('data-dbid')

        //if exist one check
        this.class = ``
        this.text = `Delete `
        this.dataDetail = `data-detail='{
                                    "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"provider", "elem":"fullcont", "act":"deleteEntity", "entity":"provider",  "dbid":[${dbid}]} ]}'`

      }/**/
    },


  ],

}/*menuBody*/